import { useCallback, useEffect, useState } from "react";
import AdministrationGeneralService from "../../../../services/administration/general";
import { FormInstance } from "antd";

export const useGetInitialData = (form: FormInstance) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [initialValue, setInitialValue] = useState<number | null>(null);

  const fetchData = useCallback(async () => {
    try {
      const res = await AdministrationGeneralService.fetchData();

      form.setFieldsValue(res);

      setInitialValue(res.nextContractNumber);

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [form]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { isLoading, initialValue, setInitialValue };
};
